import { CLEAR_ERRORS_CUSTOMERS_LOCATIONS } from 'pages/Customers/CustomersLocations/ClearErrorsLocation/actionTypes';

const clearErrorsLocation = (errors) => ({ type: CLEAR_ERRORS_CUSTOMERS_LOCATIONS, errors });

export default clearErrorsLocation;
